



































































































































































import Multiselect from 'vue-multiselect'
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import take from 'lodash/take'
import { Step } from '@/types/form'
import PhoneNumberInput from '@/components/Profil/PhoneNumberInput.vue'

/**
 * Variable utilisée pour contrôler l'utilisation des guards et du mode abstract
 */
const DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

@Component({
    components: {
        Multiselect,
        PhoneNumberInput,
    },
})
export default class Form extends Vue {
    @Prop() steps!: Step[]
    @Prop({ type: Boolean, default: false }) hideSteps

    currentStep: number = 0
    direction: 'left' | 'right' = 'left'
    error: boolean = false
    errorMessage: string | null = null
    multiselectOpened: boolean = false

    @Watch('currentStep')
    onCurrentStep() {
        this.error = false
        this.errorMessage = null
    }

    created() {
        this.$on('goToStep', step => {
            this.goToStep(step)
        })
    }

    get selectableStepsLength() {
        const validedSteps = this.steps.filter(step => {
            return step.valid
        })

        return validedSteps.length + 1
    }

    get progress() {
        const frac = 1 / this.steps.length

        return (this.currentStep + 1) * 100 * frac
    }

    async selectStep(item, index) {
        /**
         * Si on est en développement, on ne s'occupe pas du validate
         */
        if (DEV) {
            this.goToStep(index)
        }

        if (index < this.currentStep) {
            this.goToStep(index)
            return
        }

        if (index === this.currentStep) {
            return
        }

        const resp = await this.validate()

        if (!resp.valid) {
            return
        }
        this.goToStep(index)
    }

    goToStep(index: number) {
        if (this.currentStep < index) {
            this.direction = 'left'
        } else {
            this.direction = 'right'
        }

        this.currentStep = index
    }

    async validate() {
        const step = this.steps[this.currentStep]
        if (step.right.type !== 'step') {
            return
        }

        const fields = step.right.fields.map(field => {
            return field.value
        })

        const resp = await step.right.isValid(fields)
        step.valid = resp.valid

        if (resp.valid) {
            this.error = false
            this.errorMessage = null
        } else {
            this.error = true
            this.errorMessage = resp.errorMessage
        }

        return resp
    }

    async onNext() {
        const resp = await this.validate()

        if (!resp.valid) {
            return
        }

        const index = this.currentStep + 1
        this.goToStep(index)
    }

    onMultiselectOpen() {
        this.multiselectOpened = true
    }

    onMultiselectClose() {
        this.multiselectOpened = false
    }
}
